import { useIntl } from 'react-intl'
import { mdiAlert } from '@mdi/js'
import Icon from '@mdi/react'
import theme from 'theme_'

import { makePublicUrl } from 'app/utils/publicUrl'
import { purchaseSubscriptionMessages } from '../PurchaseDeviceSubscription/messages'
import {
  PurchaseStateCardSubtitleWrapper,
  PurchaseStateCardSubtitle,
  PurchaseStateCardCountSubtitle,
} from '../PurchaseDeviceSubscription/PurchaseStateSuccess/styles'
import {
  PurchaseSubscriptionScrolledContentBlock,
  PurchaseSubscriptionFinalBlockWrapper,
  PurchaseSubscritpionBlockItem,
  PurchaseSubscritpionItemTitle,
  StyledPurchaseItemImg,
  PurchaseSubscritpionFinalItemSubtitle,
} from '../PurchaseDeviceSubscription/styles'
import SubsriptionStatusInformation from './SubsriptionStatusInformation'
import { SubscriptionStatusDashboardWrapper } from './styles'
import { networkStatusMessages } from 'features/networkAi/NetworkDashboard/NetworkStatus/NetworkStatusSubscription/messages'

interface SubscriptionStatusDashboardProps {
  showStatusInformation?: boolean
  showClaimDeviceButton?: boolean
  claimedCount: number
  subscribedCount: number
}

function SubscriptionStatusDashboard({
  showStatusInformation = false,
  showClaimDeviceButton = true,
  claimedCount,
  subscribedCount,
}: SubscriptionStatusDashboardProps) {
  const { formatMessage } = useIntl()

  const hasUnclaimed = claimedCount < subscribedCount
  const isSuccess = claimedCount === subscribedCount

  return (
    <SubscriptionStatusDashboardWrapper>
      <PurchaseSubscriptionScrolledContentBlock>
        <PurchaseSubscriptionFinalBlockWrapper disabled={false}>
          <PurchaseSubscritpionBlockItem>
            <PurchaseSubscritpionItemTitle>
              {formatMessage(purchaseSubscriptionMessages.accessPointsLabel)}
            </PurchaseSubscritpionItemTitle>
          </PurchaseSubscritpionBlockItem>
          <PurchaseSubscritpionBlockItem>
            <StyledPurchaseItemImg
              src={makePublicUrl(`images/networkIcons/access-points.svg`)}
            />
            <PurchaseStateCardSubtitleWrapper>
              <PurchaseStateCardSubtitle>
                <PurchaseStateCardCountSubtitle
                  isSuccess={isSuccess || hasUnclaimed}
                >
                  {subscribedCount}
                </PurchaseStateCardCountSubtitle>
                {formatMessage(networkStatusMessages.subSubscribedText)}
              </PurchaseStateCardSubtitle>
              <PurchaseStateCardSubtitle>
                <PurchaseStateCardCountSubtitle
                  isSuccess={isSuccess || !hasUnclaimed}
                >
                  {claimedCount}
                </PurchaseStateCardCountSubtitle>
                {formatMessage(networkStatusMessages.subClaimedText)}
                {hasUnclaimed && (
                  <Icon path={mdiAlert} size={0.8} color={theme.colors.error} />
                )}
              </PurchaseStateCardSubtitle>
            </PurchaseStateCardSubtitleWrapper>
          </PurchaseSubscritpionBlockItem>
        </PurchaseSubscriptionFinalBlockWrapper>
        <PurchaseSubscriptionFinalBlockWrapper disabled>
          <PurchaseSubscritpionBlockItem>
            <PurchaseSubscritpionItemTitle>
              {formatMessage(purchaseSubscriptionMessages.switchesLabel)}
            </PurchaseSubscritpionItemTitle>
          </PurchaseSubscritpionBlockItem>
          <PurchaseSubscritpionBlockItem>
            <StyledPurchaseItemImg
              src={makePublicUrl(`images/networkIcons/switches.svg`)}
            />
            <PurchaseSubscritpionFinalItemSubtitle>
              {formatMessage(purchaseSubscriptionMessages.comingSoonLabel)}
            </PurchaseSubscritpionFinalItemSubtitle>
          </PurchaseSubscritpionBlockItem>
        </PurchaseSubscriptionFinalBlockWrapper>
        <PurchaseSubscriptionFinalBlockWrapper disabled>
          <PurchaseSubscritpionBlockItem>
            <PurchaseSubscritpionItemTitle>
              {formatMessage(purchaseSubscriptionMessages.wanEdgesLabel)}
            </PurchaseSubscritpionItemTitle>
          </PurchaseSubscritpionBlockItem>
          <PurchaseSubscritpionBlockItem>
            <StyledPurchaseItemImg
              src={makePublicUrl(`images/networkIcons/wan-edges.svg`)}
            />
            <PurchaseSubscritpionFinalItemSubtitle>
              {formatMessage(purchaseSubscriptionMessages.comingSoonLabel)}
            </PurchaseSubscritpionFinalItemSubtitle>
          </PurchaseSubscritpionBlockItem>
        </PurchaseSubscriptionFinalBlockWrapper>
      </PurchaseSubscriptionScrolledContentBlock>
      {showStatusInformation && (
        <SubsriptionStatusInformation
          showClaimDeviceButton={showClaimDeviceButton}
          claimedCount={claimedCount || 0}
          subscribedCount={subscribedCount}
        />
      )}
    </SubscriptionStatusDashboardWrapper>
  )
}

export default SubscriptionStatusDashboard
